import React from "react";
import { STTextField } from "./styles";

interface IProps {
  value: string;
  label: string;
}

export default class ProfileField extends React.Component<IProps> {
  render() {
    return (
      <STTextField
        label={this.props.label}
        defaultValue={this.props.value}
        fullWidth
        InputProps={{
          readOnly: true,
        }}
      />
    );
  }
}
